import React from 'react';
import { Button, Icon, Modal, Header } from 'semantic-ui-react'

const EstaSeguro = ({permiteUpdate, permiteDelete, permiteClose, open, styles, handleQuestionUpdDel,
                    msgUpd="Confirmar MODIFICAR", msgDel="Confirmar ELIMINAR", msgClo="Confirmar CERRAR"}) => {

console.log(permiteUpdate, permiteDelete, permiteClose, open, handleQuestionUpdDel, msgUpd)
return(
      <div>
        {(permiteUpdate || permiteDelete || permiteClose) && 
            <Modal open={open} size="tiny" style={styles.modal} trigger={
              <Button style={styles.confirmar} name="btnUpdDel" id="btnUpdDel" className="ui right labeled icon" onClick={(ev)=>handleQuestionUpdDel(ev)} primary fluid>
                {permiteUpdate && <i className="large edit yellow icon"></i>}
                {permiteDelete && <i className="large trash alternate yellow icon"></i>}
                {permiteClose && <i className="large lock yellow icon"></i>}
                {permiteUpdate && msgUpd}
                {permiteDelete && msgDel}
                {permiteClose && msgClo}

              </Button>
            }>
                {permiteUpdate && <Header icon='edit' color='red' content='Modificar' />}
                {permiteDelete && <Header icon="trash" color='red' content='Eliminar' />}
                {permiteClose && <Header icon="lock" color='red' content='Cerrar' />}
            
                <Modal.Content>
                  <p>Esta usted seguro ?</p>
                </Modal.Content>
                <Modal.Actions>
                    <Button dato1="No" name='btnNoUpd' color='red' onClick={(ev)=>handleQuestionUpdDel(ev)}>
                        <Icon dato1="No" name='remove' /> No
                    </Button>
                    <Button dato1="Si" name='btnSiUpd' color='green' onClick={(ev)=>handleQuestionUpdDel(ev)}>
                        <Icon dato1="Si" name='checkmark' /> Si
                    </Button>
                </Modal.Actions>
            </Modal>
        }
    </div> 
    )
  }

export default EstaSeguro